module.exports = __webpack_public_path__ + "static/img/Hardware-Connection-Inside-Computer-.c026ecd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/Hardware-Connection-Inside-Computer-.jpg
// module id = FWgW
// module chunks = 1